import React, { useEffect, useRef, useState } from 'react'
import {
  useGetCategoriesQuery,
  useDeleteCategoryMutation,
  useEditCategoryMutation,
} from '../../../../store/api/categoriesApi'
import { ICategory } from '../../../../types/categories'
import { Button } from '@mui/material'
import CategoriesModal from './categories-modal/CategoriesModal'
import './CategoriesPage.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { Store } from '../../../../utils/toast'
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from 'react-beautiful-dnd'
import DropComponent from './DropComponent'

const c = 'categories-page'

const CategoriesPage = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const [category, setCategory] = useState<ICategory>()
  const { data: categoriesData = [] } = useGetCategoriesQuery()
  const [categories, setCategories] = useState<ICategory[]>([])
  const [deleteCategory] = useDeleteCategoryMutation()
  const [editCategory] = useEditCategoryMutation()
  const savedScrollRef = useRef(0)

  useEffect(() => {
    if (isOpen || isOpenEdit) {
      savedScrollRef.current = window.scrollY
    } else {
      const saved = savedScrollRef.current
      if (saved) {
        setTimeout(() => window.scrollTo({ top: saved }), 50)
      }
    }
  }, [isOpen, isOpenEdit])

  useEffect(() => {
    setCategories(categoriesData)
  }, [categoriesData])

  function handleDelete(categoryId: string) {
    setCategories((prev: ICategory[]) =>
      prev.filter((category: ICategory) => categoryId !== category._id),
    )

    deleteCategory(categoryId)
      .unwrap()
      .then(() => {
        Store.addNotification({
          title: 'SUCCESS',
          message: 'Sters cu succes!',
          container: 'top-center',
          type: 'success',
          insert: 'top',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 1000,
            onScreen: true,
          },
        })
      })
  }

  function handleEdit(category: ICategory) {
    setIsOpenEdit(true)
    setCategory(category)
  }

  function handleOnDragEnd(result: DropResult) {
    if (!result.destination) {
      return
    }

    const updatedCategories = Array.from(categories)
    const [reorderedItem] = updatedCategories.splice(result.source.index, 1)

    updatedCategories.splice(result.destination.index, 0, reorderedItem)

    updatedCategories.forEach((category, index) => {
      editCategory({
        params: { ...category, position: index },
        id: category._id,
      })
    })

    setCategories(updatedCategories)
  }

  return (
    <div className={c}>
      <div className={`${c}__header`}>
        <div className={`${c}__header-title`}>Categorii</div>
        <Button
          variant='contained'
          onClick={() => setIsOpen(true)}
          sx={{
            backgroundColor: 'var(--color-primary)',
            textTransform: 'none',
            fontWeight: 700,
            borderRadius: '8px',
            '&:hover': { backgroundColor: 'var(--color-primary-hover)' },
          }}
        >
          + Adaugă
        </Button>
      </div>
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <DropComponent
          categories={categories}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      </DragDropContext>
      <CategoriesModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        categories={categories}
      />
      <CategoriesModal
        isOpen={isOpenEdit}
        setIsOpen={setIsOpenEdit}
        data={category}
        categories={categories}
      />
    </div>
  )
}

export default CategoriesPage
